import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

/**
 * Skeleton for the Policy Detail page
 * Appears when data from Confluence is being loaded for pages
 * Called by routes/policy/$paeeId.tsx
 */
export default function PageSkeleton() {

   return (
       <>
           <div className="Hero Hero--minimal Hero--policy-library-detail">
               <div className="Hero__content">
                   <div className="Breadcrumbs">
                            <span>
                                <span>
                                    <a href="#"><Skeleton width={42} inline={true}/></a>
                                </span>
                                <span className="Breadcrumbs__separator">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="19"><path d="m8.889 8.527-5.171 8.528A15.567 15.567 0 0 1 0 15.333l4.128-6.806L0 1.722A15.735 15.735 0 0 1 3.718 0l5.17 8.527Z"></path></svg>
                                </span>
                                <span>
                                     <a href="#"><Skeleton width={98} inline={true}/></a>
                                </span>
                                     <span className="Breadcrumbs__separator">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="19"><path d="m8.889 8.527-5.171 8.528A15.567 15.567 0 0 1 0 15.333l4.128-6.806L0 1.722A15.735 15.735 0 0 1 3.718 0l5.17 8.527Z"></path></svg>
                                </span>
                                <span className="breadcrumb__last">
                                    <a href="#"><Skeleton width={171} inline={true} /></a>
                                </span>
                            </span>
                   </div>
                   <h1 className="Hero__title" data-animate="true"><Skeleton /></h1>
               </div>
           </div>
           <div className="main">
               <div className="table-wrap page-skeleton-table">
                   <Skeleton height={500} />
               </div>
              <h2><Skeleton /></h2>
               <p><Skeleton count={5} /></p>

               <h2><Skeleton /></h2>
               <p><Skeleton count={5} /></p>

               <h2><Skeleton /></h2>
               <p><Skeleton count={5} /></p>

           </div>
           <div className="policy-detail-categories">
               <p><Skeleton width={82} /></p>
               <ul>
                       <li><a href="#"><Skeleton inline={true} width={50} /></a></li>
                       <li><a href="#"><Skeleton inline={true} width={70} /></a></li>
               </ul>
           </div>
       </>
   );


}